document.addEventListener('DOMContentLoaded',()=>{
  // One-time 3D print-head reveal for the red hero word.
  const startHeroPrint=()=>{
    const printWord=document.querySelector('[data-print-word]');
    if(!printWord || printWord.dataset.mwStarted==='1' || window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    printWord.dataset.mwStarted='1';
    const setPrintDistance=()=>{
      const wordWidth=printWord.getBoundingClientRect().width;
      const head=printWord.querySelector('.hero__print-head');
      const headWidth=head?.getBoundingClientRect().width||0;
      printWord.style.setProperty('--mw-print-distance',Math.max(wordWidth-headWidth*.25,0)+'px');
    };
    setPrintDistance();
    window.addEventListener('resize',setPrintDistance,{passive:true});
    requestAnimationFrame(()=>requestAnimationFrame(()=>printWord.classList.add('is-printing')));
    printWord.querySelector('.hero__print-text')?.addEventListener('animationend',(event)=>{
      if(event.animationName==='mwPrintText') printWord.classList.remove('is-printing');
    },{once:true});
  };

  // First homepage visit of the session: printer sketch creates the exact Made Weird logo.
  const splash=document.querySelector('[data-mw-splash]');
  if(splash && !document.documentElement.classList.contains('mw-splash-seen')){
    document.body.classList.add('mw-splash-lock');
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const splashLogo=splash.querySelector('.mw-splash__logo-mask img');
    let splashStarted=false;
    const runSplash=()=>{
      if(splashStarted)return;
      splashStarted=true;
      const splashDuration=reduced?700:3650;
      window.setTimeout(()=>{
        splash.classList.add('is-leaving');
        try{sessionStorage.setItem('mwSplashSeen','1')}catch(e){}
        window.setTimeout(()=>{
          splash.remove();
          document.body.classList.remove('mw-splash-lock');
          startHeroPrint();
        },420);
      },splashDuration);
    };
    if(splashLogo && !splashLogo.complete){
      splashLogo.addEventListener('load',runSplash,{once:true});
      window.setTimeout(runSplash,900);
    }else{
      runSplash();
    }
  }else{
    startHeroPrint();
  }

  const drawer=document.querySelector('[data-mobile-drawer]');
  const setDrawer=(open)=>{
    if(!drawer)return;
    drawer.classList.toggle('is-open',open);
    document.body.classList.toggle('menu-open',open);
    drawer.setAttribute('aria-hidden',open?'false':'true');
    document.querySelectorAll('[data-mobile-menu]').forEach(b=>b.setAttribute('aria-expanded',open?'true':'false'));
  };
  document.addEventListener('click',(event)=>{
    const btn=event.target.closest('[data-mobile-menu]');
    if(!btn)return;
    event.preventDefault();
    event.stopPropagation();
    setDrawer(!drawer?.classList.contains('is-open'));
  });
  document.addEventListener('keydown',(event)=>{ if(event.key==='Escape') setDrawer(false); });

  document.querySelectorAll('[data-qty-change]').forEach(btn=>btn.addEventListener('click',()=>{
    const input=btn.parentElement.querySelector('input[type=number]'); if(!input)return;
    const d=Number(btn.dataset.qtyChange); input.value=Math.max(0,Number(input.value||0)+d); input.form?.submit();
  }));


  // Product-page quantity selector: instant +/- with tactile feedback.
  document.querySelectorAll('[data-product-qty]').forEach((control)=>{
    const input=control.querySelector('[data-product-qty-input]');
    const minus=control.querySelector('[data-product-qty-minus]');
    const plus=control.querySelector('[data-product-qty-plus]');
    if(!input || !minus || !plus)return;

    const sync=()=>{
      let qty=Math.max(1,parseInt(input.value,10)||1);
      input.value=qty;
      minus.disabled=qty<=1;
    };

    const feedback=()=>{
      try{if('vibrate' in navigator)navigator.vibrate(18);}catch(e){}
    };

    minus.addEventListener('click',()=>{
      const current=Math.max(1,parseInt(input.value,10)||1);
      if(current<=1)return;
      input.value=current-1;
      sync();
      feedback();
      input.dispatchEvent(new Event('change',{bubbles:true}));
    });

    plus.addEventListener('click',()=>{
      const current=Math.max(1,parseInt(input.value,10)||1);
      input.value=current+1;
      sync();
      feedback();
      input.dispatchEvent(new Event('change',{bubbles:true}));
    });

    input.addEventListener('input',sync);
    input.addEventListener('change',sync);
    sync();
  });

  document.querySelectorAll('[data-product-gallery]').forEach(gallery=>{
    const track=gallery.querySelector('[data-product-track]');
    const slides=[...gallery.querySelectorAll('[data-product-slide]')];
    const current=gallery.querySelector('[data-gallery-current]');
    if(!track||slides.length<2)return;
    const go=(dir)=>{
      const left=track.scrollLeft;
      let idx=Math.round(left/Math.max(track.clientWidth,1));
      idx=Math.max(0,Math.min(slides.length-1,idx+dir));
      slides[idx].scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});
    };
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>go(-1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click',()=>go(1));
    let ticking=false;
    track.addEventListener('scroll',()=>{
      if(ticking)return; ticking=true;
      requestAnimationFrame(()=>{
        const idx=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/Math.max(track.clientWidth,1))));
        if(current)current.textContent=idx+1;
        ticking=false;
      });
    },{passive:true});
  });

  // Frictionless AJAX Add to Cart: stay on product page, update cart count, haptic/tactile feedback.
  const mwCartToast=document.querySelector('[data-cart-toast]');
  let mwCartToastTimer;
  const mwShowCartToast=(message)=>{
    if(!mwCartToast)return;
    const copy=mwCartToast.querySelector('[data-cart-toast-copy]');
    if(copy && message)copy.textContent=message;
    mwCartToast.setAttribute('aria-hidden','false');
    mwCartToast.classList.add('is-visible');
    clearTimeout(mwCartToastTimer);
    mwCartToastTimer=setTimeout(()=>{
      mwCartToast.classList.remove('is-visible');
      mwCartToast.setAttribute('aria-hidden','true');
    },2600);
  };
  const mwRoot=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  const mwGetCart=()=>fetch(`${mwRoot}cart.js`,{headers:{Accept:'application/json'}}).then(r=>r.json());
  const mwEarringCount=(cart)=>{
    const knownTitles=['8 bit heart','bow down','flight mode','curl cat','crazy daisy'];
    return (cart.items||[]).reduce((sum,item)=>{
      const props=item.properties||{};
      const rawTitle=String(item.product_title||item.title||'').toLowerCase();
      const title=rawTitle.replace(/[‐‑‒–—-]+/g,' ').replace(/\s+/g,' ').trim();
      const type=String(item.product_type||'').toLowerCase();
      const isEarring=
        props._mw_earring_bundle==='yes' ||
        title.includes('earring') ||
        type.includes('earring') ||
        knownTitles.some(name=>title.includes(name));
      return sum+(isEarring?Number(item.quantity||0):0);
    },0);
  };
  const mwUpdateRewards=(cart)=>{
    const qty=mwEarringCount(cart);

    document.querySelectorAll('[data-earring-rewards]').forEach(box=>{
      const count=qty;
      const copy=box.querySelector('[data-earring-reward-copy]');
      const progress=box.querySelector('[data-earring-progress]');
      let pct=0;
      if(count<=3) pct=(count/3)*33.333;
      else if(count<=5) pct=33.333+((count-3)/2)*33.333;
      else pct=66.666+((Math.min(count,10)-5)/5)*33.334;
      if(progress) progress.style.width=`${Math.max(0,Math.min(100,pct))}%`;
      box.querySelectorAll('[data-reward-dot]').forEach(dot=>{
        const threshold=Number(dot.dataset.rewardDot||0);
        dot.classList.toggle('is-reached',count>=threshold);
      });
      box.querySelectorAll('[data-reward-milestone]').forEach(item=>{
        const threshold=Number(item.dataset.rewardMilestone||0);
        item.classList.toggle('is-reached',count>=threshold);
      });
      if(!copy)return;
      if(count<3){
        const left=3-count;
        copy.textContent=`FREE SHIPPING ACROSS INDIA · Add ${5-count} pairs for +1 FREE`;
      }else if(count<5){
        const left=5-count;
        copy.textContent=`FREE SHIPPING ACROSS INDIA ✓ · Add ${left} more ${left===1?'pair':'pairs'} for +1 FREE`;
      }else if(count<10){
        const left=10-count;
        copy.textContent=`+1 FREE PAIR unlocked ✓ · ${left} more to unlock +2 FREE`;
      }else{
        copy.textContent=`MAX WEIRD unlocked ✓ · FREE SHIPPING + 2 FREE PAIRS`;
      }
    });
  };

  document.querySelectorAll('form[data-ajax-product-form]').forEach(form=>{
    form.addEventListener('submit',async(event)=>{
      const submitter=event.submitter;
      if(!submitter || !submitter.matches('[data-ajax-add]'))return;
      event.preventDefault();
      if(submitter.disabled)return;
      const label=submitter.querySelector('[data-add-label]');
      const original=label?.textContent||'ADD TO CART';
      submitter.disabled=true;
      submitter.classList.add('is-adding');
      if(label)label.textContent='ADDING...';
      try{
        const res=await fetch(`${mwRoot}cart/add.js`,{
          method:'POST',
          headers:{Accept:'application/json'},
          body:new FormData(form)
        });
        if(!res.ok)throw new Error('Cart add failed');
        // Haptic where supported. iOS Safari currently ignores the Vibration API, so the visual press remains the fallback.
        try{if('vibrate' in navigator)navigator.vibrate([38,22,38]);}catch(e){}
        submitter.classList.remove('is-adding');
        submitter.classList.add('is-added');
        if(label)label.textContent='ADDED ✓';
        const cart=await mwGetCart();
        document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=`(${cart.item_count})`);
        mwUpdateRewards(cart);
        mwShowCartToast('Added ✓ It’s in your cart. Keep shopping if you want.');
        window.setTimeout(()=>{
          submitter.disabled=false;
          submitter.classList.remove('is-added');
          if(label)label.textContent=original;
        },1400);
      }catch(err){
        submitter.disabled=false;
        submitter.classList.remove('is-adding');
        submitter.classList.add('is-error');
        if(label)label.textContent='TRY AGAIN';
        mwShowCartToast('Couldn’t add that one. Please try once more.');
        window.setTimeout(()=>{
          submitter.classList.remove('is-error');
          if(label)label.textContent=original;
        },1800);
      }
    });
  });
  if(document.querySelector('[data-earring-rewards]')){
    mwGetCart().then(mwUpdateRewards).catch(()=>{});
  }

  // Secret footer Easter egg: five taps/clicks unlock a tiny brand moment.
  const weirdButton=document.querySelector('[data-weird-button]');
  const weirdToast=document.querySelector('[data-weird-toast]');
  const weirdConfetti=document.querySelector('[data-weird-confetti]');
  let weirdClicks=0;
  let weirdReset;
  if(weirdButton){
    weirdButton.addEventListener('click',()=>{
      weirdClicks+=1;
      clearTimeout(weirdReset);
      weirdReset=setTimeout(()=>{weirdClicks=0;},2800);
      weirdButton.classList.remove('is-pop');
      void weirdButton.offsetWidth;
      weirdButton.classList.add('is-pop');
      if(weirdClicks>=5){
        weirdClicks=0;
        weirdToast?.classList.add('is-visible');
        if(weirdConfetti){
          weirdConfetti.innerHTML='';
          for(let i=0;i<56;i++){
            const bit=document.createElement('i');
            const x=(2+((i*37)%96));
            const delay=((i%14)*.035);
            const rotation=((i*53)%360);
            const drift=(-90+((i*71)%180));
            const size=(7+((i*11)%9));
            bit.style.setProperty('--x',`${x}%`);
            bit.style.setProperty('--delay',`${delay}s`);
            bit.style.setProperty('--rot',`${rotation}deg`);
            bit.style.setProperty('--drift',`${drift}px`);
            bit.style.setProperty('--size',`${size}px`);
            weirdConfetti.appendChild(bit);
          }
          weirdConfetti.classList.remove('is-live');
          void weirdConfetti.offsetWidth;
          weirdConfetti.classList.add('is-live');
        }
        setTimeout(()=>weirdToast?.classList.remove('is-visible'),3400);
      }
    });
  }

});


/* === MADE WEIRD REAL-TIME CART CONTROLS — KEY BASED === */
(() => {
  const money = (cents, currency='INR') => {
    try {
      return new Intl.NumberFormat('en-IN', {
        style:'currency',
        currency: currency || 'INR',
        minimumFractionDigits: 2
      }).format((Number(cents)||0)/100);
    } catch(e) {
      return `Rs. ${((Number(cents)||0)/100).toFixed(2)}`;
    }
  };

  const knownEarrings=['8 bit heart','bow down','flight mode','curl cat','crazy daisy'];

  const isEarringItem=(item)=>{
    const props=item.properties||{};
    const rawTitle=String(item.product_title||item.title||'').toLowerCase();
    const title=rawTitle.replace(/[‐‑‒–—-]+/g,' ').replace(/\s+/g,' ').trim();
    const type=String(item.product_type||'').toLowerCase();
    return (
      props._mw_earring_bundle==='yes' ||
      title.includes('earring') ||
      type.includes('earring') ||
      knownEarrings.some(name=>title.includes(name))
    );
  };

  const updateRewards=(cart)=>{
    const qty=(cart.items||[]).reduce(
      (sum,item)=>sum+(isEarringItem(item)?Number(item.quantity||0):0),
      0
    );

    const showLowPriceNudge = qty===0 && Number(cart.total_price||0) < 20000;

    document.querySelectorAll('[data-cart-earring-rewards]').forEach(box=>{
      box.classList.toggle('is-hidden', qty===0);
    });

    document.querySelectorAll('[data-low-price-nudge]').forEach(box=>{
      box.classList.toggle('is-hidden', !showLowPriceNudge);
      const copy=box.querySelector('[data-low-price-copy]');
      if(copy && showLowPriceNudge){
        const left=Math.max(0,20000-Number(cart.total_price||0));
        const rupees=Math.ceil(left/100);
        copy.textContent=`FREE SHIPPING ACROSS INDIA`;
      }
    });


    document.querySelectorAll('[data-earring-rewards]').forEach(box=>{
      const count=qty;
      const copy=box.querySelector('[data-earring-reward-copy]');
      const progress=box.querySelector('[data-earring-progress]');
      let pct=0;
      if(count<=3) pct=(count/3)*33.333;
      else if(count<=5) pct=33.333+((count-3)/2)*33.333;
      else pct=66.666+((Math.min(count,10)-5)/5)*33.334;
      if(progress) progress.style.width=`${Math.max(0,Math.min(100,pct))}%`;
      box.querySelectorAll('[data-reward-dot]').forEach(dot=>{
        const threshold=Number(dot.dataset.rewardDot||0);
        dot.classList.toggle('is-reached',count>=threshold);
      });
      box.querySelectorAll('[data-reward-milestone]').forEach(item=>{
        const threshold=Number(item.dataset.rewardMilestone||0);
        item.classList.toggle('is-reached',count>=threshold);
      });
      if(!copy)return;
      if(count<3){
        const left=3-count;
        copy.textContent=`FREE SHIPPING ACROSS INDIA · Add ${5-count} pairs for +1 FREE`;
      }else if(count<5){
        const left=5-count;
        copy.textContent=`FREE SHIPPING ACROSS INDIA ✓ · Add ${left} more ${left===1?'pair':'pairs'} for +1 FREE`;
      }else if(count<10){
        const left=10-count;
        copy.textContent=`+1 FREE PAIR unlocked ✓ · ${left} more to unlock +2 FREE`;
      }else{
        copy.textContent=`MAX WEIRD unlocked ✓ · FREE SHIPPING + 2 FREE PAIRS`;
      }
    });
  };

  const updateGlobalCartUI=(cart)=>{
    document.querySelectorAll('[data-cart-count]').forEach(el=>{
      el.textContent=`(${cart.item_count})`;
    });

    const total=document.querySelector('[data-cart-total]');
    if(total)total.textContent=money(cart.total_price,cart.currency);

    updateRewards(cart);

    const form=document.querySelector('[data-cart-form]');
    if(form && cart.item_count===0){
      const page=form.closest('.page-width');
      form.remove();
      document.querySelector('[data-earring-rewards]')?.remove();
      document.querySelector('[data-low-price-nudge]')?.remove();

      if(page && !page.querySelector('.cart-empty-state')){
        const empty=document.createElement('div');
        empty.className='cart-empty-state';
        empty.innerHTML='<p>Your cart is suspiciously normal.</p><a class="btn btn--red" href="/collections/all">FIX THAT</a>';
        page.appendChild(empty);
      }
    }
  };

  const findCartItem=(cart,key)=>{
    return (cart.items||[]).find(item=>String(item.key)===String(key));
  };

  const syncMinusState=(row)=>{
    if(!row)return;
    const input=row.querySelector('[data-cart-quantity]');
    const minus=row.querySelector('[data-cart-decrease]');
    if(!input || !minus)return;
    const qty=Math.max(1,Number(row.dataset.desiredQty ?? input.value)||1);
    minus.disabled=qty<=1;
    minus.setAttribute('aria-disabled',qty<=1?'true':'false');
  };

  /*
   * Each row keeps its own desired quantity.
   * If the customer taps + + + quickly while Shopify is still responding,
   * the UI changes immediately and the newest quantity is synced next.
   */
  const syncRow=async(row)=>{
    if(!row || row.dataset.cartSyncing==='true')return;

    const key=row.dataset.cartKey;
    if(!key)return;

    row.dataset.cartSyncing='true';
    row.classList.add('is-updating');

    try{
      while(row.isConnected){
        const input=row.querySelector('[data-cart-quantity]');
        if(!input)break;

        const desired=Math.max(0,Number(row.dataset.desiredQty ?? input.value)||0);
        const sent=Number(row.dataset.sentQty ?? -1);

        if(desired===sent)break;
        row.dataset.sentQty=String(desired);

        const response=await fetch('/cart/change.js',{
          method:'POST',
          headers:{
            'Content-Type':'application/json',
            'Accept':'application/json'
          },
          body:JSON.stringify({id:key,quantity:desired})
        });

        if(!response.ok)throw new Error(`Cart update failed: ${response.status}`);

        const cart=await response.json();
        updateGlobalCartUI(cart);

        let liveItem=findCartItem(cart,key);

        // Defensive fallback: Shopify can occasionally return a refreshed line-item key.
        if(!liveItem){
          const variantId=Number(row.dataset.cartVariantId||0);
          if(variantId){
            liveItem=(cart.items||[]).find(item=>Number(item.variant_id)===variantId);
            if(liveItem && liveItem.key)row.dataset.cartKey=String(liveItem.key);
          }
        }

        // Item was intentionally removed.
        if(!liveItem){
          row.classList.add('is-removing');
          await new Promise(resolve=>setTimeout(resolve,180));
          row.remove();
          break;
        }

        // Only replace the visible qty if the user has not already tapped again.
        const newestDesired=Math.max(0,Number(row.dataset.desiredQty ?? desired)||0);
        if(newestDesired===desired){
          input.value=liveItem.quantity;
          row.dataset.desiredQty=String(liveItem.quantity);
        }
        syncMinusState(row);

        const price=row.querySelector('[data-cart-line-price]');
        if(price)price.textContent=money(liveItem.final_line_price,cart.currency);

        if(newestDesired===liveItem.quantity){
          row.dataset.sentQty=String(liveItem.quantity);
          break;
        }
      }
    }catch(error){
      console.error(error);
      // Pull the real cart as a recovery so UI never stays in a false state.
      try{
        const recovery=await fetch('/cart.js',{headers:{Accept:'application/json'}});
        if(recovery.ok){
          const cart=await recovery.json();
          updateGlobalCartUI(cart);
          const item=findCartItem(cart,row.dataset.cartKey);
          if(item){
            const input=row.querySelector('[data-cart-quantity]');
            const price=row.querySelector('[data-cart-line-price]');
            if(input)input.value=item.quantity;
            if(price)price.textContent=money(item.final_line_price,cart.currency);
            row.dataset.desiredQty=String(item.quantity);
            row.dataset.sentQty=String(item.quantity);
          }
        }
      }catch(e){}
    }finally{
      if(row.isConnected){
        row.dataset.cartSyncing='false';
        row.classList.remove('is-updating');

        const desired=Number(row.dataset.desiredQty ?? 0);
        const sent=Number(row.dataset.sentQty ?? -1);
        if(desired!==sent){
          syncRow(row);
        }
      }
    }
  };

  const setDesiredQuantity=(row,qty,{allowZero=false}={})=>{
    if(!row)return;
    const input=row.querySelector('[data-cart-quantity]');
    if(!input)return;

    qty=Number(qty)||0;
    qty=allowZero?Math.max(0,qty):Math.max(1,qty);

    // Immediate visual response. Do not block the +/- buttons while Shopify syncs.
    input.value=qty;
    row.dataset.desiredQty=String(qty);
    syncMinusState(row);

    try{
      if('vibrate' in navigator)navigator.vibrate(16);
    }catch(e){}

    syncRow(row);
  };

  document.addEventListener('click',(event)=>{
    const btn=event.target.closest(
      '[data-cart-increase],[data-cart-decrease],[data-cart-remove]'
    );
    if(!btn)return;

    event.preventDefault();

    const row=btn.closest('[data-cart-line]');
    const input=row?.querySelector('[data-cart-quantity]');
    if(!row || !input)return;

    const current=Math.max(
      0,
      Number(row.dataset.desiredQty ?? input.value)||0
    );

    if(btn.matches('[data-cart-increase]')){
      setDesiredQuantity(row,current+1);
    }else if(btn.matches('[data-cart-decrease]')){
      // Minus only reduces quantity. It never deletes an item.
      if(current<=1)return;
      setDesiredQuantity(row,current-1);
    }else{
      // Deletion happens only from the explicit REMOVE button.
      setDesiredQuantity(row,0,{allowZero:true});
    }
  });

  document.addEventListener('change',(event)=>{
    const input=event.target.closest('[data-cart-quantity]');
    if(!input)return;

    const row=input.closest('[data-cart-line]');
    if(!row)return;

    setDesiredQuantity(row,Math.max(1,Number(input.value)||1));
  });

  // Initialise row state from server-rendered quantities.
  document.querySelectorAll('[data-cart-line]').forEach(row=>{
    const input=row.querySelector('[data-cart-quantity]');
    if(!input)return;
    row.dataset.desiredQty=String(input.value);
    row.dataset.sentQty=String(input.value);
    row.dataset.cartSyncing='false';
    syncMinusState(row);
  });
})();

